<div class="detected-accident-container" *transloco="let t; prefix: 'accidents'">
  <div class="table-container">
    <div class="table-inner">
      @if (isLoading) {
        <div class="loading-overlay">
          <span class="spinner-border"></span>
        </div>
      } @else if (hasError) {
        <div class="state-overlay">
          <app-error-state></app-error-state>
        </div>
      } @else if (!rows.length) {
        <div class="state-overlay">
          <app-empty-state></app-empty-state>
        </div>
      }

      <table class="detected-accidents-table" [class.table-page-full]="rows.length === pageSize">
        <thead>
          <tr>
            <th class="accident">{{ t('detectedAccident.table.accident') }}</th>
            <th class="asset">{{ t('detectedAccident.table.asset') }}</th>
            <th class="driver">{{ t('detectedAccident.table.driver') }}</th>
            <th class="date-time">{{ t('detectedAccident.table.dateAndTime') }}</th>
            <th class="location">{{ t('detectedAccident.table.location') }}</th>
            <th class="driver-status">{{ t('detectedAccident.table.driverStatus') }}</th>
            <th class="status">{{ t('detectedAccident.table.status') }}</th>
            <th class="actions">{{ t('detectedAccident.table.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          @if(!isLoading && !hasError) {
            @for(accident of rows; track accident.accidentId) {
              <tr class="detected-accident-row">
                <td class="accident"><span class="cell-text">{{ accident.accidentNumber }}</span></td>
                <td class="asset"><span class="cell-text">{{ accident.assetName }}</span></td>
                <td class="driver"><span class="cell-text">{{ accident.driverName || emptyValue }}</span></td>
                <td class="date-time"><span class="cell-text cell-text--single">{{ accident.dateAndTime | date: dateTimeFormat }}</span></td>
                <td class="location">
                  <button type="button" class="location-link" [title]="accident.location" (click)="onViewLocation(accident)">
                    <span class="cell-text">{{ accident.location }}</span>
                  </button>
                </td>
                <td class="driver-status">
                  <app-driver-call-status [callResult]="accident.callResult" [driverStatus]="accident.driverStatus"></app-driver-call-status>
                </td>
                <td class="status">
                  @if (getStatus(accident); as status) {
                    <span class="status-badge" [ngClass]="getStatusClass(status)">
                      @if(status === detectedAccidentStatus.Verified) {
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM6.66603 10.9407L4.1907 8.4707L5.13203 7.5267L6.6647 9.0567L10.194 5.52736L11.1367 6.47003L6.66603 10.9407Z" fill="#50AD41"/>
                        </svg>
                      } @else if(status === detectedAccidentStatus.FalsePositive) {
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203Z" fill="#9FA1A4"/>
                        </svg>
                      } @else if(status === detectedAccidentStatus.NotVerified) {
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.9987 1.33203C4.3227 1.33203 1.33203 4.3227 1.33203 7.9987C1.33203 11.6747 4.3227 14.6654 7.9987 14.6654C11.6747 14.6654 14.6654 11.6747 14.6654 7.9987C14.6654 4.3227 11.6747 1.33203 7.9987 1.33203ZM10.194 11.1367L7.33203 8.2747V3.9987H8.66536V7.7227L11.1367 10.194L10.194 11.1367Z" fill="#F4BC2B"/>
                        </svg>
                      }
                      <span>{{ statusLabelKeys[status] | transloco }}</span>
                    </span>
                  }
                </td>
                <td class="actions">
                  <button
                    class="claim-insurance-btn"
                    [class.disabled]="isClaimDisabled(accident)"
                    [disabled]="isClaimDisabled(accident)"
                    (click)="onClaimInsurance(accident)">
                    {{ t('detectedAccident.fileInsuranceClaim') }}
                  </button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="table-footer">
      <p class="pagination-text">
        {{ 'common.showingOutOf' | transloco: { current: showingCount, total: totalCount } }}
      </p>

      <app-pagination
        [totalPages]="totalPages"
        [currentPage]="page"
        (pageChange)="goToPage($event)">
      </app-pagination>

    </div>
  </div>
</div>